import produce from 'immer'
import { Reducer } from 'redux'

import {
  SET_ALL_USERS,
  SET_USER_URN
} from 'redux/actions/types'

interface UsersState {
  allUsers: any[]|null;
  userUrn: string| null
}

const initialState: UsersState = {
  allUsers: null,
  userUrn: null
}

const users:Reducer<UsersState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_USERS:
      return produce(state, draft => {
        draft.allUsers = action.allUsers
      })
    case SET_USER_URN:
      return produce(state, draft => {
        draft.userUrn = action.userUrn
      })
    default:
      return state
  }
}

export default users
